export default __webpack_public_path__ + "static/sounds-780b3f4acec5d2adcb1dd1e538944466.jpg";